module.exports = __webpack_public_path__ + "static/media/Grocery.cdbf0eb1.svg";